export var convertToServerAccountData = function (data) {
    var _a;
    return {
        companyName: data.companyName,
        phoneNumber: (_a = data.mainPhoneNumber) === null || _a === void 0 ? void 0 : _a.replaceAll(' ', ''),
        payersRegistrationNumber: data.payersRegistrationNumber,
        paymentAccount: data.paymentAccount,
        bankIdNumber: data.bankIdNumber,
        directorFullName: data.directorFullName,
        bankAddress: data.bankAddress,
        companyAddress: data.companyAddress,
        companyDescription: data.compannyInfo,
        additionalPhoneNumbers: data.phoneNumbers.map(function (ph) { return ({
            number: ph.number.replaceAll(' ', ''),
            id: ph.id,
        }); }),
        formFile: data.formFile || null,
    };
};
